import { useTranslation } from 'react-i18next'

import { ComboBox, Text } from '@reveni-io/reveni-ui'

import useReturnInstructionSelector from './hooks/useReturnInstructionSelector/useReturnInstructionSelector'
import ReturnInstructionPreview from './ReturnInstructionPreview/ReturnInstructionPreview'
import { getHelperText, getPreviewSteps, getSelectedInstruction } from './helpers'
import * as Styles from './styles'

const ReturnInstructionSelector = ({ storeId, instructionType, selectedInstructionSetId, onChange }) => {
  const { t, i18n } = useTranslation()
  const { data, loading } = useReturnInstructionSelector({ storeId, instructionType })

  const selectedInstruction = getSelectedInstruction(data, selectedInstructionSetId)
  const previewSteps = getPreviewSteps(selectedInstruction, i18n.language)
  const helperText = getHelperText({ instructionType, loading, hasOptions: data.length > 0, t })

  const handleChange = e => {
    onChange({ return_instruction_set_id: e.target.value })
  }

  return (
    <Styles.Container>
      <Text type="titleS">{t('Instrucciones de devolución')}</Text>
      <Text type="bodyMRegular">
        {t(
          'Selecciona el conjunto de instrucciones de devolución que se enviará por email al cliente para que sepa cómo devolver sus productos a la tienda.'
        )}
      </Text>
      <ComboBox
        fullWidth
        label={t('Instrucciones')}
        disabled={!instructionType || (!loading && !data.length)}
        value={selectedInstructionSetId || ''}
        handleChange={handleChange}
        menuItems={data.map(option => ({
          value: option.id,
          label: option.name,
        }))}
        helperText={helperText}
        loading={loading}
      />
      {selectedInstruction && <ReturnInstructionPreview steps={previewSteps} />}
    </Styles.Container>
  )
}

export default ReturnInstructionSelector
